module.exports = __webpack_public_path__ + "static/img/youxiaTitle.a88af47.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mImage/youxiaTitle.png
// module id = jeze
// module chunks = 0